__webpack_require__.p = "/ui-mark-notification-as-read/onboarding/";